export default __webpack_public_path__ + "static/r7-bf959ff649727fad602f7af5988fc342.png";